import type { DriveStep } from 'driver.js';

export const methodsTourSteps: DriveStep[] = [
  {
    element: '[data-tour="methods-search"]',
    popover: {
      title: 'Methoden durchsuchen',
      description: 'Über 50 professionelle Coaching-Methoden — durchsuche sie nach Name, Kategorie oder Thema.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="methods-create"]',
    popover: {
      title: 'Eigene Methode erstellen',
      description: 'Du hast eine eigene Coaching-Methode? Erstelle sie hier mit Schritt-für-Schritt-Anleitung und Arbeitsblättern.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-tour="methods-shop"]',
    popover: {
      title: 'Methoden-Shop',
      description: 'Im Shop findest du weitere Premium-Methoden, die du mit Credits freischalten kannst.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-tour="methods-grid"]',
    popover: {
      title: 'Methoden-Übersicht',
      description: 'Klicke auf eine Methode, um die Anleitung, Arbeitsblätter und Einsatzgebiete zu sehen. Du kannst sie direkt in einer Sitzung verwenden.',
      side: 'top',
      align: 'center',
    },
  },
];
